// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"image_wrapper__5Ygli"};